import paronApi from '@/utils/paron-api'

export default {
    getAllSponsors(page = 1, perPage = 60) {
        return paronApi.get(`sponsor/all?page=${page}&per_page=${perPage}`)
    },

    getSponsorById(id) {
        return paronApi.get(`sponsor/${id}`)
    },

    createSponsor(data) {
        return paronApi.uploadFile('sponsor/new', data)
    },

    editSponsorById(id, data) {
        return paronApi.uploadFile(`sponsor/${id}/edit`, data)
    },

    deleteSponsorById(id) {
        return paronApi.delete(`sponsor/${id}`)
    }

}
